import { Observable } from "rxjs";
import { PageRequest } from "src/app/support/page-request";
import { Paginated } from "src/app/support/paginated";
import { UUID } from "src/app/support/uuid";

import { MedicationsLoad } from "../models/medications/ medications.load";
import { Medication } from "../models/medications/medications";

import { MedicationCreate } from "../models/medications/medications.create";
import { MedicationsDelete } from "../models/medications/medications.delete";
import { MedicationsUpdate } from "../models/medications/medications.update";

export abstract class MedicationsBackend {
  abstract load(request: MedicationsLoad): Observable<Medication>;
  abstract list(request: PageRequest): Observable<Paginated<Medication>>;
  abstract create(request: MedicationCreate): Observable<UUID>;
  abstract update(request: MedicationsUpdate): Observable<void>;
  abstract delete(request: MedicationsDelete): Observable<void>;
}
